import { GET_PLANT } from '../actions'

const INITIAL_STATE = {}

function PlantsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_PLANT:
            return {
                ...state,
                [action.payload.body.id]: action.payload.body,
            }
        default: return state
    }
}

export default PlantsReducer



// WEBPACK FOOTER //
// ./src/reducers/plants.js